import { Outlet, Route, createRoutesFromElements } from 'react-router-dom'

import { AuthChecker } from '@/components/AuthChecker.tsx'
import { CookiePolicyPopup } from '@/components/CookiePolicyPopup.tsx'
import { ProjectProviders } from '@/contexts/ProjectProviders.tsx'
import { AcceptInvitationPage } from '@/pages/AcceptInvitationPage.tsx'
import { CookiePolicyPage } from '@/pages/CookiePolicyPage.tsx'
import { DataProcessingAddendum } from '@/pages/DataProcessingAddendum.tsx'
import { LandingPage } from '@/pages/LandingPage.tsx'
import { LoginPage } from '@/pages/LoginPage.tsx'
import { MembersPage } from '@/pages/MembersPage.tsx'
import { NotFoundPage } from '@/pages/NotFoundPage.tsx'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage.tsx'
import { ProjectAnalyticsAcceptedStoriesPage } from '@/pages/ProjectAnalyticsAcceptedStoriesPage.tsx'
import { ProjectAnalyticsPage } from '@/pages/ProjectAnalyticsPage.tsx'
import { ProjectAnalyticsReleaseDetailsPage } from '@/pages/ProjectAnalyticsReleaseDetailsPage.tsx'
import { ProjectAnalyticsReleasesPage } from '@/pages/ProjectAnalyticsReleasesPage.tsx'
import { ProjectPage } from '@/pages/ProjectPage.tsx'
import { ProjectSettingsPage } from '@/pages/ProjectSettingsPage.tsx'
import { ProjectsPage } from '@/pages/ProjectsPage.tsx'
import { SecurityMeasuresPage } from '@/pages/SecurityMeasuresPage.tsx'
import { StoryCycleTimeDetailsPage } from '@/pages/StoryCycleTimeDetailsPage.tsx'
import { SubprocessorsPage } from '@/pages/SubprocessorsPage.tsx'
import { TermsOfServicePage } from '@/pages/TermsOfServicePage.tsx'
import { TermsOfUsePage } from '@/pages/TermsOfUsePage.tsx'
import { WelcomePage } from '@/pages/WelcomePage.tsx'
import { ProjectAnalyticsLayout } from '@/pages/layout/ProjectAnalyticsLayout.tsx'
import { ProjectLayout } from '@/pages/layout/ProjectLayout.tsx'

export const appRoutes = createRoutesFromElements(
  <Route
    element={
      <>
        <Outlet />
        <CookiePolicyPopup />
      </>
    }
  >
    <Route path="/" element={<LandingPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/invites/:invitationCode" element={<AcceptInvitationPage />} />
    <Route path="/welcome" element={<WelcomePage />} />
    <Route path="/policies">
      <Route path="terms-of-use" element={<TermsOfUsePage />} />
      <Route path="trackerboot-agreement" element={<TermsOfServicePage />} />
      <Route path="data-processing-addendum" element={<DataProcessingAddendum />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="cookie-policy" element={<CookiePolicyPage />} />
    </Route>
    <Route path="/legal">
      <Route path="subprocessors" element={<SubprocessorsPage />} />
      <Route path="security-measures" element={<SecurityMeasuresPage />} />
    </Route>
    <Route element={<AuthChecker />}>
      <Route
        element={
          <ProjectLayout>
            <Outlet />
          </ProjectLayout>
        }
      >
        <Route path="/projects" element={<ProjectsPage />} />
      </Route>
      <Route path="/project/:projectId/analytics" element={<ProjectProviders />}>
        <Route
          element={
            <ProjectAnalyticsLayout>
              <Outlet />
            </ProjectAnalyticsLayout>
          }
        >
          <Route index element={<ProjectAnalyticsPage />} />
          <Route path="cycle-times" element={<StoryCycleTimeDetailsPage />} />
          <Route path="stories-accepted" element={<ProjectAnalyticsAcceptedStoriesPage />} />
        </Route>
      </Route>
      <Route path="/project/:projectId/releases" element={<ProjectProviders />}>
        <Route
          element={
            <ProjectAnalyticsLayout>
              <Outlet />
            </ProjectAnalyticsLayout>
          }
        >
          <Route index element={<ProjectAnalyticsReleasesPage />} />
          <Route path=":releaseId" element={<ProjectAnalyticsReleaseDetailsPage />} />
        </Route>
      </Route>
      <Route path="/project/:projectId" element={<ProjectProviders />}>
        <Route
          element={
            <ProjectLayout>
              <Outlet />
            </ProjectLayout>
          }
        >
          <Route index element={<ProjectPage />} />
          <Route path="members" element={<MembersPage />} />
          <Route path="settings" element={<ProjectSettingsPage />} />
        </Route>
      </Route>
    </Route>
    <Route path="*" element={<NotFoundPage />} />
  </Route>,
)
